// extracted by mini-css-extract-plugin
module.exports = {"toiplusFooter":"AlAu5","footerNav":"f0JD1"};